
export enum DoorPlanActionCd {
	COPY = 'Copy',
	MERGE = 'Merge',
	MOVE = 'Move',
	REVERT = 'Revert',
	SWAP = 'Swap'}

